export const WS_PROTOCOL = 'wss';
export const WS_IP = 'backend-websocket.fsharechat.cn/ws';
export const HTTP_IP = 'backend-http.fsharechat.cn';
// export const WS_IP = 'localhost';
export const WS_PORT = 9326;
export const HTTP_HOST = "https://"+HTTP_IP + "/"
export const LOGIN_API = HTTP_HOST + "login";
export const SNED_VERIFY_CODE_API = HTTP_HOST + "send_code";;
export const HEART_BEAT_INTERVAL = 25 * 1000;
export const RECONNECT_INTERVAL = 30 * 1000;
export const BINTRAY_TYPE = 'blob';
//是否使用七牛上传文件
export const UPLOAD_BY_QINIU = false;


// WEBPACK FOOTER //
// ./src/fscommon/constant/config.js